import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { augmentPaging, DataWithPagingMetadata } from '~/infrastructure/paging';
import {
  StockCycleCountChunkDetailModel,
  StockCycleCountChunkModel,
  StockCycleCountTransactionModel,
  StockUpdateCycleCountDetailsModel
} from '~/models/modules/Stocks/Transactions/StockCycleCount/StockCycleCount';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({ providedIn: 'root' })
export class StockCycleCountService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  LoadDataRandomly(percentage: number, transactionId: number | null, countType: number): Observable<StockCycleCountChunkDetailModel[]> {
    const txId = transactionId ?? 0;
    return this.client.get<StockCycleCountChunkDetailModel[]>(this._url(`/data-randomly/${percentage}/${txId}/${countType}`));
  }

  LoadDraftedTransaction(): Observable<StockCycleCountTransactionModel> {
    return this.client.get<StockCycleCountTransactionModel>(this._url(`/drafted-transaction`));
  }

  LoadOpenedTransaction(): Observable<StockCycleCountTransactionModel> {
    return this.client.get<StockCycleCountTransactionModel>(this._url(`/opened-transaction`));
  }

  Process(model: StockCycleCountChunkModel): Observable<any> {
    return this.client.post(this._url(``), model);
  }

  UpdateDetails(model: StockUpdateCycleCountDetailsModel): Observable<any> {
    return this.client.put(this._url(``), model);
  }

  getStockCycleCountHistory(paramsObj?: any, model?: any): Observable<DataWithPagingMetadata<any>> {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    const params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  private _url(v?: string | undefined): string {
    v = v || '';
    return this.url(`/StockCycleCountTransaction${v}`);
  }
}
